export default "__VITE_ASSET__DynyOEXN__"